export const MOCK_DATA: Record<string, any>[] = [
  {
    "display_name": "TestCreateBundle",
    "type": "STANDARD",
    "id": "50c37a45-e70e-4a7a-851e-22e8b1ddb409",
    "bundle_guid": "c6ce22b2-f9a9-46bf-a6ca-c66117a795cc",
    "created_date": "2026-07-30T20:25:51.740Z",
    "updated_date": "2026-07-30T20:25:51.740Z",
    "organization_id": "62f17051-00f6-4e2e-90fe-3f80981e27f4"
  },
  {
    "display_name": "TestMockQE",
    "type": "QUOTE_EXPERIENCE",
    "id": "caa1c8fa-2497-4560-b8d4-8d2be56ccea9",
    "bundle_guid": "5e0d4c71-00d1-4f26-958d-750fe0784ce3",
    "created_date": "2026-07-31T05:34:14.271Z",
    "updated_date": "2026-07-31T05:34:14.271Z",
    "organization_id": "62f17051-00f6-4e2e-90fe-3f80981e27f4"
  }
];